import { iconDataUrl, UI_ACCENT } from '../ui/icons';
import { parseUrlOptions } from './urlOptions';
import { checkCapabilities, getMissingCapabilities } from './capabilities';
import type { UrlOptions } from './types';
import type { ErrorModal } from '../ui/types';

export function checkStartup(win: Window, errorModal: ErrorModal): UrlOptions | null {
  const urlResult = parseUrlOptions(win.location.search);
  if (!urlResult.ok) {
    errorModal.show('Invalid URL Parameters', [urlResult.error]);
    return null;
  }

  const missing = getMissingCapabilities(checkCapabilities());
  if (missing.length > 0) {
    errorModal.show('WebGL Requirements Not Met', [
      'Your browser does not support the required WebGL features:',
      ...missing,
    ]);
    return null;
  }
  return urlResult.value;
}
/* Without an icon link Chromium requests /favicon.ico, which this static site does not serve. The
   icon is built from lucide's icon data, like the HUD icons, rather than drawn by hand. */
export function installFavicon(doc: Document): void {
  const link = doc.createElement('link');
  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.href = iconDataUrl('painter', UI_ACCENT);
  doc.head.append(link);
}
